module.exports = __webpack_public_path__ + "static/media/featuresection3.e30cd16b.png";